module.exports = __webpack_public_path__ + "static/media/tl_logo.d93ff3bc.jpg";